import { useSearchParams } from 'react-router-dom';
import { z } from 'zod';

export const useFormsListSearchParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const rawParams = {
    page: searchParams.get('page'),
    id: searchParams.get('id'),
    search: searchParams.get('search'),
    from: searchParams.get('from'),
    to: searchParams.get('to'),
    sortOrder: searchParams.get('sortOrder'),
  };
  const params = {
    page: rawParams.page,
    id: rawParams.id,
    name: rawParams.search,
    updatedFrom: rawParams.from,
    updatedTo: rawParams.to,
    sortDir: z.enum(['asc', 'desc']).parse(rawParams.sortOrder ?? 'desc'),
  };
  const filtersParamsActive = Object.entries(rawParams).some(
    ([key, value]) => !['sortOrder', 'page'].includes(key) && value !== null,
  );
  const clearFiltersParams = () => {
    Object.entries(rawParams).forEach(([key, value]) => {
      if (value !== null) {
        console.log(key);
        searchParams.delete(key);
      }
    });
    setSearchParams(searchParams);
  };

  return { params, filtersParamsActive, clearFiltersParams };
};
